import * as Yup from 'yup';

import {
  BuscaPersonalizadaGrupoEleitoresForm,
  Button,
  DefaultCard,
  DocentesLotacaoEquipeProgramaForm,
  FormSwitcher,
} from '../../../components';
import { ButtonTypeEnum, TipoFiltroBuscaEleitoresDocenteEnum, TipoGrupoEleitoresEnum } from '../../../enums';
import DocentesLecionandoDepartamentoCursoForm, {
  initialValuesDocentesLecionandoDepartamentoCursoForm,
  onSubmitDocentesLecionandoDepartamentoCursoForm,
  validationSchemaDocentesLecionandoDepartamentoCursoForm,
} from './DocentesLecionandoDepartamentoCursoForm';
import { Form, Formik } from 'formik';
import { FunctionComponent, useState } from 'react';
import {
  initialValuesBuscaPersonalizadaGrupoEleitoresForm,
  onSubmitBuscaPersonalizadaGrupoEleitoresForm,
  validationSchemaBuscaPersonalizadaGrupoEleitoresForm,
} from '../BuscaPersonalizadaGrupoEleitoresForm';
import {
  initialValuesDocentesExternosEquipeProgramaForm,
  onSubmitDocentesExternosEquipeProgramaForm,
  validationSchemaDocentesExternosEquipeProgramaForm,
} from './DocentesExternosEquipeProgramaForm';
import {
  initialValuesDocentesExternosLecionandoCursoForm,
  onSubmitDocentesExternosLecionandoCursoForm,
  validationSchemaDocentesExternosLecionandoCursoForm,
} from './DocentesExternosLecionandoCursoForm';
import {
  initialValuesDocentesLotacaoEquipeProgramaForm,
  onSubmitDocentesLotacaoEquipeProgramaForm,
  validationSchemaDocentesLotacaoEquipeProgramaForm,
} from './DocentesLotacaoEquipeProgramaForm';
import { useAuthAxios, useErrorHandler, useErrorStatus } from '../../../hooks';

import { BuscaEleitoresDocentesType } from '../../../types';
import { useTranslation } from 'react-i18next';

const BuscaEleitoresDocentes: FunctionComponent<BuscaEleitoresDocentesType> = ({
  handleLimparBusca,
  setLoading,
  setResultado,
}) => {
  const { t } = useTranslation();
  const axios = useAuthAxios();

  const [initialValuesSelectedForm, setInitialValuesSelectedForm] = useState({
    selectedForm: t('label.docentes_por_lotacao'),
  });
  const [validationSchemaSelectedForm, setValidationSchemaSelectedForm] = useState(
    Yup.object().shape({
      selectedForm: Yup.string().required(t('validacao.campo_obrigatorio')),
    }),
  );
  const [onSubmitSelectedForm, setOnSubmitSelectedForm] = useState<any>(() => {});
  const [title, setTitle] = useState<string>(t('label.busca_eleitores'));
  const { setErrorStatus } = useErrorStatus();
  const errorHandler = useErrorHandler();

  return (
    <Formik
      validateOnMount
      enableReinitialize
      initialValues={initialValuesSelectedForm}
      validationSchema={validationSchemaSelectedForm}
      onSubmit={onSubmitSelectedForm}
    >
      {(props) => (
        <Form id="busca">
          <DefaultCard
            cardTitle={title}
            cardSubtitle={t('texto.filtros_eleitores')}
            footer={
              <div className={'d-flex justify-content-center gap-5'}>
                <Button
                  title={t('label.limpar_busca')}
                  type={ButtonTypeEnum.BUTTON}
                  outline
                  onClick={handleLimparBusca}
                  disabled={props.isSubmitting || props.isValidating}
                />
                <Button
                  title={t('label.buscar')}
                  type={ButtonTypeEnum.SUBMIT}
                  disabled={props.isSubmitting || props.isValidating || !!props.errors?.selectedForm}
                />
              </div>
            }
          >
            <FormSwitcher
              setInitialValues={setInitialValuesSelectedForm}
              setValidationSchema={setValidationSchemaSelectedForm}
              setOnSubmit={setOnSubmitSelectedForm}
              setCardTitle={setTitle}
              formikProps={props}
              formikFieldName="selectedForm"
              forms={[
                {
                  descricao: t('texto.form_docentes_por_lotacao'),
                  form: DocentesLotacaoEquipeProgramaForm,
                  initialValues: initialValuesDocentesLotacaoEquipeProgramaForm(t, TipoFiltroBuscaEleitoresDocenteEnum.LOTACAO),
                  label: t('label.docentes_por_lotacao'),
                  onSubmit: onSubmitDocentesLotacaoEquipeProgramaForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoFiltroBuscaEleitoresDocenteEnum.LOTACAO,
                  ),
                  props: {
                    tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.LOTACAO,
                  },
                  validationSchema: validationSchemaDocentesLotacaoEquipeProgramaForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LOTACAO,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_lecionando_no_departamento'),
                  form: DocentesLecionandoDepartamentoCursoForm,
                  initialValues: initialValuesDocentesLecionandoDepartamentoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_DEPARTAMENTO,
                  ),
                  label: t('label.docentes_lecionando_no_departamento'),
                  onSubmit: onSubmitDocentesLecionandoDepartamentoCursoForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_DEPARTAMENTO,
                  ),
                  props: { tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_DEPARTAMENTO },
                  validationSchema: validationSchemaDocentesLecionandoDepartamentoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_DEPARTAMENTO,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_lecionando_no_curso'),
                  form: DocentesLecionandoDepartamentoCursoForm,
                  initialValues: initialValuesDocentesLecionandoDepartamentoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO,
                  ),
                  label: t('label.docentes_lecionando_no_curso'),
                  onSubmit: onSubmitDocentesLecionandoDepartamentoCursoForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO,
                  ),
                  props: { tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO },
                  validationSchema: validationSchemaDocentesLecionandoDepartamentoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_externos_lecionando_no_curso'),
                  form: DocentesLecionandoDepartamentoCursoForm,
                  initialValues: initialValuesDocentesExternosLecionandoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO,
                  ),
                  label: t('label.docentes_externos_lecionando_no_curso'),
                  onSubmit: onSubmitDocentesExternosLecionandoCursoForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                  ),
                  props: { tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO },
                  validationSchema: validationSchemaDocentesExternosLecionandoCursoForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_na_equipe_programa_pos_graduacao'),
                  form: DocentesLotacaoEquipeProgramaForm,
                  initialValues: initialValuesDocentesLotacaoEquipeProgramaForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  ),
                  label: t('label.docentes_na_equipe_programa_pos_graduacao'),
                  onSubmit: onSubmitDocentesLotacaoEquipeProgramaForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  ),
                  props: {
                    tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  },
                  validationSchema: validationSchemaDocentesLotacaoEquipeProgramaForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_externos_na_equipe_programa_pos_graduacao'),
                  form: DocentesLotacaoEquipeProgramaForm,
                  initialValues: initialValuesDocentesExternosEquipeProgramaForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  ),
                  label: t('label.docentes_externos_na_equipe_programa_pos_graduacao'),
                  onSubmit: onSubmitDocentesExternosEquipeProgramaForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                  ),
                  props: {
                    tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  },
                  validationSchema: validationSchemaDocentesExternosEquipeProgramaForm(
                    t,
                    TipoFiltroBuscaEleitoresDocenteEnum.EQUIPE_PROGRAMA,
                  ),
                },
                {
                  descricao: t('texto.form_docentes_por_siape'),
                  form: BuscaPersonalizadaGrupoEleitoresForm,
                  initialValues: initialValuesBuscaPersonalizadaGrupoEleitoresForm(t, TipoGrupoEleitoresEnum.DOCENTE),
                  label: t('label.docentes_por_siape'),
                  onSubmit: onSubmitBuscaPersonalizadaGrupoEleitoresForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoGrupoEleitoresEnum.DOCENTE,
                  ),
                  props: {
                    tipoGrupoEleitores: TipoGrupoEleitoresEnum.DOCENTE,
                  },
                  validationSchema: validationSchemaBuscaPersonalizadaGrupoEleitoresForm(t, TipoGrupoEleitoresEnum.DOCENTE),
                },
                {
                  descricao: t('texto.form_docentes_externos_por_matricula'),
                  form: BuscaPersonalizadaGrupoEleitoresForm,
                  initialValues: initialValuesBuscaPersonalizadaGrupoEleitoresForm(t, TipoGrupoEleitoresEnum.DOCENTE_EXTERNO),
                  label: t('label.docentes_externos_por_matricula'),
                  onSubmit: onSubmitBuscaPersonalizadaGrupoEleitoresForm(
                    t,
                    axios,
                    setResultado,
                    setLoading,
                    setErrorStatus,
                    errorHandler,
                    TipoGrupoEleitoresEnum.DOCENTE_EXTERNO,
                  ),
                  props: {
                    tipoGrupoEleitores: TipoGrupoEleitoresEnum.DOCENTE_EXTERNO,
                  },
                  validationSchema: validationSchemaBuscaPersonalizadaGrupoEleitoresForm(
                    t,
                    TipoGrupoEleitoresEnum.DOCENTE_EXTERNO,
                  ),
                },
              ]}
            />
          </DefaultCard>
        </Form>
      )}
    </Formik>
  );
};

export default BuscaEleitoresDocentes;
